import { gql } from '@apollo/client';
import React from 'react';
import { Field, FieldSet } from '../../components/Form';
import type { ProfilesTab_IntegrationFragment } from '../../graphql/generated/graphqlTypes';
import type { IntegrationPlatformInfo } from '../../integrations/IntegrationPlatformInfo';

const INTEGRATION_FRAGMENT = gql`
  fragment ProfilesTab_integration on Integration {
    id
    platform
    settings {
      enableEnrich
    }
  }
`;

interface ProfilesTabProps {
  platformInfo: IntegrationPlatformInfo;
}

const ProfilesTab = ({ platformInfo }: ProfilesTabProps) => {
  return (
    <FieldSet>
      <Field
        name="enableEnrich"
        type="checkbox"
        label={`Enable ${platformInfo.name} profile sync on sign-up`}
      />
    </FieldSet>
  );
};

ProfilesTab.fragments = {
  integration: INTEGRATION_FRAGMENT,
};

ProfilesTab.getFormValues = ({
  settings,
}: ProfilesTab_IntegrationFragment) => ({
  enableEnrich: settings?.enableEnrich || false,
});
ProfilesTab.getNewSettings = (
  values: ReturnType<typeof ProfilesTab.getFormValues>,
) => ({ enableEnrich: values.enableEnrich });

export default ProfilesTab;
